import ErrorComponent from "@components/ErrorComponent/ErrorComponent/ErrorComponent";
import SomethingWentWrongImage from "@assets/icons/common/something_went_wrong_illustration.svg?react";

function SomethingWentWrong() {
  return (
    <ErrorComponent
      image={<SomethingWentWrongImage className="pb-[12px]" />}
      title="Oops, Something Went Wrong"
      subTitle={
        <>
          <div>That didn’t work as expected. Please retry shortly.</div>
          <div> If this keeps happening, let us know.</div>
        </>
      }
    />
  );
}

export default SomethingWentWrong;
